import React, { useState, useRef, useEffect, useContext } from 'react';
import styles from './Navbar.module.css';
import { FaUserCircle, FaBars } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../context/UserContext';
import NotificationBell from './notifications/NotificationBell';
import logo from '../assets/img/Logo_light.png';

const Navbar = ({ onLogout }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [profileOpen, setProfileOpen] = useState(false);
  const profileRef = useRef(null);
  const navigate = useNavigate();
  const user = useContext(UserContext);

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const toggleProfile = () => setProfileOpen((prev) => !prev);

  // Close profile dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (profileRef.current && !profileRef.current.contains(e.target)) {
        setProfileOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLogoutClick = () => {
    onLogout();             // clear context + localStorage
    navigate('/');          // redirect to login
  };

  const handleProfileClick = (e) => {
    e && e.preventDefault && e.preventDefault();
    const role = (user && (user.role || user.user?.role)) || null;
    if (role === 'student') {
      navigate('/profile');
    } else {
      navigate('/employee-profile');
    }
    setProfileOpen(false);
  };

  return (
    <nav className={styles.navbar}>
      <div className={styles.logo}> 
        <img src={logo} alt="Logo" className={styles.logoimg} />
        </div>

      <ul className={`${styles.navLinks} ${menuOpen ? styles.show : ''}`}>
        <li><a href="/home">Dashboard</a></li>
        <li><a href="/recordings">Recordings</a></li>
         {user?.role === 'student' && (
          <>
           <li><a href="/courses">Courses</a></li>
           <li><a href="https://github.com/bst-code" target='_blank'>Github_repo</a></li>
          </>

         )}
         {user?.role === 'superAdmin' && (
             <>
            <li><a href="/pages">Page List</a></li>
            <li><a href="/create">Create Page</a></li>
            <li><a href="/grant-access">Grant Access</a></li>
             <li><a href="/getmeeting">Meetings</a></li>
            </>

         )}
       
        {user?.role === 'admin' && (
       <>
            <li><a href="/grant-access">Grant Access</a></li>
             <li><a href="/getmeeting">Meetings</a></li>
          </>
        )}
        {user?.role === 'trainer' && (
       <>
             <li><a href="/getmeeting">Meetings</a></li>
          </>
        )}
      </ul>

      <div className={styles.rightIcons}>
        <NotificationBell />
        <div className={styles.profileWrapper} ref={profileRef}>
          <FaUserCircle className={styles.profileIcon} onClick={toggleProfile} />
          <div className={`${styles.profileMenu} ${profileOpen ? styles.open : ''}`}>
            <button className={styles.profileLink} onClick={handleProfileClick}>Profile</button>
            <button className={styles.logoutBtn} onClick={handleLogoutClick}>Logout</button>
          </div>
        </div>

        <div className={styles.hamburger} onClick={toggleMenu}>
          <FaBars />
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
